import { createContext } from 'react';
import {
  IManager,
  IResetPasswordRequest,
  ISigninRequest
} from '../commons/interfaces/auth.interface';

interface AuthContextType {
  user: IManager | null;
  signin: (requestData: ISigninRequest) => Promise<void>;
  signout: () => void;
  isLoggedIn: () => boolean;
  isAccessTokenExpired: () => boolean;
  refresh: () => Promise<void>;
  loading: boolean;
  recoveryPassword: (email: string) => Promise<void>;
  resetPassword: (requestData: IResetPasswordRequest) => Promise<void>;
}

const AuthContext = createContext<AuthContextType>(null!);

export default AuthContext;
